import { dataHooks } from '@wix/data-hooks';

export const floatingBannerDataHooks = dataHooks<{
  root;
  content;
  sectionHelper;
}>('floating-banner');
